export { default } from './Facility';
export type { Props, Props as FacilityCardProps } from './Facility';
